require('./cardPaymentPurchaseDeferralStep.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')
const { getChosenDeferralText, getDeferralMonthsText, isLavandaCard, getTinAndTaeValues } = require('utilities/lavandaHelper');
// @ commons
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
// @ constants
const TRANSLATION_KEY_PREFIX = 'cardPaymentPurchaseDeferralStep-';
const FIRST_INSTALLMENT = 0;
const { TAE, TIN } = require('constants/lavanda');

class CardPaymentPurchaseDeferralStep extends React.Component {

    buildList(immCard, immCardPaymentPurchaseDeferral, immMovement, immGlobalVariables, isLavandaFlow) {
        const { chosenDeferral, isLastStep, quotaStep } = this.props;
        const commerceName = immMovement.get('description');
        const financedPurchasedAmount = immMovement.get('import');
        const operationDate = DateHelper.formatDate(immMovement.get('date'));
        const operationTime = immMovement.get('time');
        const plainAmountObject = getPlainAmountObject(financedPurchasedAmount);
        const quotaQuantity = immCardPaymentPurchaseDeferral.getIn(['steps', quotaStep, 'installmentQuantity']);
        const deferralMonthsText = getDeferralMonthsText(quotaQuantity);
        const language = getLanguage();

        let interestsComponent;
        let quotaValueComponent;
        let quotaQuantityComponent;
        let totalAmountComponent;
        let deferralOption;
        let content;
        let interestTae;
        let interestTin;
        let taeExample;
        let interestMn;
        if(isLavandaFlow) {
            const globalParameters = !!immGlobalVariables && immGlobalVariables.getIn(['variables', 'parameters']);
            const tinAndTae = getTinAndTaeValues(isLavandaFlow, chosenDeferral, immCard, globalParameters);
            interestTae = tinAndTae[TAE];
            interestTin = tinAndTae[TIN];
        }else if (immCard.get('isDiamond')) {
            const immPackDiamondPercentages = immGlobalVariables.getIn(['variables', 'parameters', 'pack_diamond', 'pago_facil_paga_despues']);
            interestMn = immPackDiamondPercentages.get('nominal');
            interestTae = immPackDiamondPercentages.get('tae');
            interestTin = immPackDiamondPercentages.get('tin');
            taeExample = formatText('cardPayLater-taePremiumDiamondExample');
        } else if(immCard.get('isPremium')) {
            const immPackPremiumPercentages = immGlobalVariables.getIn(['variables', 'parameters', 'pack_premium', 'pago_facil_paga_despues']);
            interestMn = immPackPremiumPercentages.get('nominal');
            interestTae = immPackPremiumPercentages.get('tae');
            interestTin = immPackPremiumPercentages.get('tin');
            taeExample = formatText('cardPayLater-taePremiumDiamondExample');
        } else if(immCard.get('isRevolving')) {
            const immRevolvingPackPercentages = immGlobalVariables.getIn(['variables', 'parameters', `revolving_pack_${immCard.get('revolvingPack')}`, 'pago_facil_paga_despues']);
            interestMn = immRevolvingPackPercentages.get('nominal');
            interestTae = immRevolvingPackPercentages.get('tae');
            interestTin = immRevolvingPackPercentages.get('tin');
        } else {
            const immOpenCreditPercentages = immGlobalVariables.getIn(['variables', 'parameters', 'open_credit', 'pago_facil_paga_despues']);
            interestMn = immOpenCreditPercentages.get('nominal');
            interestTae = immOpenCreditPercentages.get('tae');
            interestTin = immOpenCreditPercentages.get('tin');
            taeExample = formatText(`${TRANSLATION_KEY_PREFIX}deferPurchaseTaeTooltip`);
        }
        if (isLastStep){
            const interests = immCardPaymentPurchaseDeferral.getIn(['steps', quotaStep, 'totalInterests']);
            const quotaValue = isLavandaFlow ? immCardPaymentPurchaseDeferral.getIn(['steps', quotaStep, 'quotaMonthly']) : immCardPaymentPurchaseDeferral.getIn(['steps', quotaStep, 'installmentsList', FIRST_INSTALLMENT, 'installmentTotal']);
            const totalAmount = immCardPaymentPurchaseDeferral.getIn(['steps', quotaStep, 'totalAmount']);
            const plainAmountInterestObject = getPlainAmountObject(interests);
            const plainAmountQuotaObject = getPlainAmountObject(quotaValue);
            const plainAmountTotalObject = getPlainAmountObject(totalAmount);
            const deferral = getChosenDeferralText(chosenDeferral);
            const totalAmountText = isLavandaFlow ? 'lavanda-lavanda_creditAmount' : TRANSLATION_KEY_PREFIX + 'totalAmount';

            interestsComponent = (
                <OKInformativeListItem
                    title={TRANSLATION_KEY_PREFIX + 'interests'}
                >
                    <OneLineSymbolAmount
                        className="card-payment-purchase-deferral-step__amount"
                        amountObject={plainAmountInterestObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountInterestObject, true)} />
                </OKInformativeListItem>
            );

            const quotaKey = isLavandaFlow ? 'mensualQuota' : 'quotaValue';
            quotaValueComponent = (
                <OKInformativeListItem
                    title={TRANSLATION_KEY_PREFIX + quotaKey}
                >
                    <OneLineSymbolAmount
                        className="card-payment-purchase-deferral-step__amount"
                        amountObject={plainAmountQuotaObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountQuotaObject, true)} />
                </OKInformativeListItem>
            );

            quotaQuantityComponent = (
                <OKInformativeListItem
                    title={TRANSLATION_KEY_PREFIX + 'quotaQuantity'}
                    bodyText={quotaQuantity}
                />
            );

            totalAmountComponent = (
                <OKInformativeListItem
                    title={totalAmountText}
                >
                    <OneLineSymbolAmount
                        className="card-payment-purchase-deferral-step__amount"
                        amountObject={plainAmountTotalObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountTotalObject, true)} />
                </OKInformativeListItem>
            );
            
            if (isLavandaFlow) {
                deferralOption = (
                    <OKInformativeListItem
                        title="lavanda-lavanda_chosenDeferral"
                        bodyText={deferral}
                    />
                );
            }
        }

        if (isLavandaFlow) {
            content = (
                <OKInformativeList columns={2}>
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'financedPurchasedAmount'}
                    >
                        <OneLineSymbolAmount
                            positiveAmount className="card-payment-purchase-deferral-step__amount"
                            amountObject={plainAmountObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'tae'}
                        icon={taeExample ? "icon-pregunta" : ''}
                        information={taeExample}
                        tooltipOffset={[15, 0]}
                        bodyText={interestTae}
                        isDarkTitle={isLavandaFlow}
                    >
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'description'}
                        bodyText={commerceName}
                    />
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'tin'}
                        bodyText={interestTin}
                    />
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'operationDate'}
                        bodyText={operationDate}
                    />
                    <OKInformativeListItem
                        title="lavanda-lavanda_purchaseNature"
                        bodyText="lavanda-lavanda_paymentDeferral"
                    />
                    <OKInformativeListItem
                        title="lavanda-lavanda_deferralDuration"
                        bodyText={deferralMonthsText}
                    />
                    {quotaValueComponent}
                    {deferralOption}
                    {totalAmountComponent}
                    {quotaQuantityComponent}
                    {interestsComponent}
                </OKInformativeList>
            );
        } else {
            content = (
                <OKInformativeList columns={2}>
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'commerceName'}
                        bodyText={commerceName}
                    />
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'financedPurchasedAmount'}
                    >
                        <OneLineSymbolAmount
                            positiveAmount className="card-payment-purchase-deferral-step__amount"
                            amountObject={plainAmountObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'operationDate'}
                        bodyText={operationDate}
                    />
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'operationTime'}
                        bodyText={operationTime}
                    />
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'tin'}
                        bodyText={interestTin}
                    />
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'tae'}
                        icon={taeExample ? "icon-pregunta" : ''}
                        information={taeExample}
                        tooltipOffset={[15, 0]}
                        bodyText={interestTae}
                        isDarkTitle={isLavandaFlow}
                    >
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'monthlyNominal'}
                        bodyText={interestMn}
                    />
                    {interestsComponent}
                    {quotaValueComponent}
                    {quotaQuantityComponent}
                    {totalAmountComponent}
                </OKInformativeList>
            )
        }

        return content;
    }

    buildDeferralOptions(isLavandaFlow){
        const { children, isLastStep } = this.props;
        let content = (
            <section className="card-payment-purchase-deferral-step__children">
                {children}
            </section>
        );

        if (!isLastStep && isLavandaFlow){
            content = (
                <OKInformativeList columns={1}>
                    <OKInformativeListItem
                        title="lavanda-lavanda_deferralOptions"
                    >
                        {children}
                    </OKInformativeListItem>
                </OKInformativeList>
            );
        }

        return content;
    }

    render() {
        const {
            immCard,
            immLavanda,
            immCardPaymentPurchaseDeferral,
            immGlobalVariables,
            lavandaEnabled,
            titleKey,
            subtitleKey,
            immMovement,
            isLastStep
        } = this.props;

        const isLavandaFlow = lavandaEnabled && isLavandaCard(immCard.get('product'), immLavanda.get('cards'));
        const list = this.buildList(immCard, immCardPaymentPurchaseDeferral, immMovement, immGlobalVariables, isLavandaFlow);

        let subtitleLabel;

        if (subtitleKey) {
            subtitleLabel = <p><FormattedText value={subtitleKey} /></p>;
        }

        const operativeName=formatText('operatives-paymentPurchaseDeferral_cards')
        const cardPaymentPurchaseClassName = contactCenterClassName('card-payment-purchase-deferral-step__header-text')

        return (
            <article className="card-payment-purchase-deferral-step">
                <article>
                    <header className="card-payment-purchase-deferral-step__header">
                        <FormattedText
                            value={titleKey}
                            className={cardPaymentPurchaseClassName}
                        />
                    </header>
                    <ContactCenterRender>
                        {
                            isLastStep
                            &&
                            <ConfirmationScript
                                confirmationType={CONFIRMATION_SCRIPT_GREETING}
                                operative={operativeName}
                            />
                        }
                    </ContactCenterRender>
                    <section className="card-payment-purchase-deferral-step__content">
                        {subtitleLabel}
                        <section className="card-payment-purchase-deferral-step__list">
                            {list}
                        </section>
                        <ContactCenterRender>
                            {
                                isLastStep
                                &&
                                <ConfirmationScript
                                    confirmationType={CONFIRMATION_SCRIPT_AGREEMENT}
                                />
                            }
                        </ContactCenterRender>
                        {this.buildDeferralOptions(isLavandaFlow)}
                    </section>
                </article>
            </article>
        );
    }
}

CardPaymentPurchaseDeferralStep.propTypes = {
    children: PropTypes.any.isRequired,
    chosenDeferral: PropTypes.string,
    immCard: PropTypes.object.isRequired,
    immLavanda: PropTypes.object,
    immCardPaymentPurchaseDeferral: PropTypes.object.isRequired,
    immMovement: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object,
    lavandaEnabled: PropTypes.bool,
    quotaStep: PropTypes.number.isRequired,
    titleKey: PropTypes.string.isRequired,
    subtitleKey: PropTypes.string,
    isLastStep: PropTypes.bool
};

CardPaymentPurchaseDeferralStep.defaultProps = {
    lavandaEnabled: false,
    subtitleKey: ''
}

module.exports = CardPaymentPurchaseDeferralStep;
